import {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'front-onceforall-core';

class HelpContentPreview extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedCategory: null
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.history.replace(`${this.props.currentPath}?help=${this.props.content.id}`);
  }

  render() {
    return (
      <div
        className="box clickable col-12 mb-3 inline-container"
        onClick={this.handleClick}
      >
        <div className="information-light mr-2">
          <Icon
            size={24}
            icon={this.props.icon}
          />
        </div>
        <div>
          <div data-id="title">{this.props.content.title}</div>
          <div data-id="description">{this.props.content.description}</div>
        </div>
      </div>
    );
  }
}

HelpContentPreview.propTypes = {
  currentPath: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  content: PropTypes.object.isRequired,
  icon: PropTypes.string.isRequired
};

export default HelpContentPreview;
